/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_WhatInputs */

const en_mk_cmp_linear_what = /** @type {(inputs: Mk_Cmp_Linear_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linear is a very fast issue and project tracker, widely used by product and engineering teams. Since 2025–2026 they have opened an agent path: third-party agents (Cursor, Codex, Devin and others) can be assigned or mentioned, with session states of pending, active, awaitingInput and complete. Annual per-seat pricing: Free $0, Basic $10, Business $16, Enterprise by agreement; AI credits are bought separately with a $10 minimum.`)
};

const id_mk_cmp_linear_what = /** @type {(inputs: Mk_Cmp_Linear_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linear adalah pelacak issue dan proyek yang sangat cepat, dipakai luas oleh tim produk dan engineering. Sejak 2025–2026 mereka membuka jalur agen: agen pihak ketiga (Cursor, Codex, Devin, dan lainnya) bisa di-assign atau di-mention, dengan status sesi pending, active, awaitingInput, dan complete. Harga per kursi tahunan: Free $0, Basic $10, Business $16, Enterprise sesuai kesepakatan; kredit AI dibeli terpisah minimal $10.`)
};

/**
* | output |
* | --- |
* | "Linear is a very fast issue and project tracker, widely used by product and engineering teams. Since 2025–2026 they have opened an agent path: third-party ag..." |
*
* @param {Mk_Cmp_Linear_WhatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_what = /** @type {((inputs?: Mk_Cmp_Linear_WhatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_WhatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_what(inputs)
	return en_mk_cmp_linear_what(inputs)
});